export const WORKSPACE_TYPES = [
  "B2B - SaaS",
  "B2B - Agency",
  "B2B - Professional Services",
  "B2B - Financial Services",
  "B2B - Manufacturing",
  "B2B - Wholesale",
  "B2C - E-commerce",
  "B2C - Retail",
  "B2C - Services",
  "D2C - E-commerce",
  "D2C - Retail",
  "D2C - Services",
  "D2C - Digital Products",
  "D2C - Hospitality",
  "B2B2C - Marketplace",
  "B2B2C - Platform",
  "Creator - Influencer",
  "Creator - Musician",
  "Creator - Podcaster",
  "Creator - Artist",
  "Local - Home Services",
  "Local - Health & Wellness",
  "Local - Food & Beverage",
  "Local - Professional Services",
  "Local - Real Estate",
  "Education",
  "Non-Profit"
];
